import type * as React from "react";

import { ToastItemStyled, ToastCloseButtonStyled } from "./styles";

type ToastItemProps = {
    text: React.ReactNode;
    onClick?(): void;
    linkText?: string;
    href?: string;
    showCloseIcon?: boolean;
    onClose?(): void;
};

const ToastItem: React.FC<ToastItemProps> = ({ text, onClick, linkText, href, showCloseIcon, onClose }) => {
    return (
        <ToastItemStyled>
            <span>{text}</span>
            {linkText ? (
                <a
                    href={href}
                    onClick={onClick}
                    data-automation="toast-link"
                >
                    {linkText}
                </a>
            ) : null}
            {showCloseIcon ? (
                <ToastCloseButtonStyled
                    onClick={onClose}
                    type="flat"
                    iconName="close"
                    iconSize="xs"
                />
            ) : null}
        </ToastItemStyled>
    );
};

export const getToastItemComponent = (props: ToastItemProps) => <ToastItem {...props} />;
